import { render, staticRenderFns } from "./AtendimentoResumo.vue?vue&type=template&id=fb514866&scoped=true&"
import script from "./AtendimentoResumo.vue?vue&type=script&lang=js&"
export * from "./AtendimentoResumo.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoResumo.vue?vue&type=style&index=0&id=fb514866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb514866",
  null
  
)

export default component.exports